import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { installAdminViewFetch } from './utils/authSession'

installAdminViewFetch();

console.log('🚦 Traffic Lite - main.tsx loading...');

const stagingHost = typeof window !== 'undefined'
  && window.location.hostname.toLowerCase() === 'traffic-lite-front-end-staging.netlify.app';
const fallbackScale = stagingHost ? 0.9 : 1;
const parsedUiScale = Number(import.meta.env.VITE_UI_SCALE ?? String(fallbackScale));
const uiScale = Number.isFinite(parsedUiScale) && parsedUiScale > 0 ? parsedUiScale : fallbackScale;
if (typeof document !== 'undefined' && uiScale !== 1) {
  // Mirrors browser zoom behavior so 100% can feel like 90%.
  document.documentElement.style.zoom = String(uiScale);
}

const rootElement = document.getElementById("root");
console.log('Root element:', rootElement);

if (rootElement) {
  console.log('Creating React root...');
  const root = createRoot(rootElement);
  console.log('Rendering App component...');
  root.render(<App />);
  console.log('App rendered successfully!');
} else {
  console.error('❌ Root element not found!');
}
